import React from "react";
import { useMsal } from "@azure/msal-react";
import './SignOutLink.css';
/**
 * Renders a sign-out button
 */
export const SignOutLink = () => {
    const { instance } = useMsal();

    const handleLogout = (logoutType: string) => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    }

    return (

        
        <a href="#" className="pds-link-emphasis avatar-logout" data-gtm="call-to-action" onClick={() => handleLogout("popup")}>
          LoginOut
        </a>
    );
}